"use client"

import { useEffect, useState } from "react"

export function ConnectivityIndicator() {
  const [isOnline, setIsOnline] = useState(true)

  useEffect(() => {
    // Browser online/offline events keep this state in sync after hydration.
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener("online", handleOnline)
    window.addEventListener("offline", handleOffline)

    const timeoutId = window.setTimeout(() => {
      setIsOnline(navigator.onLine)
    }, 0)
    return () => {
      window.clearTimeout(timeoutId)
      window.removeEventListener("online", handleOnline)
      window.removeEventListener("offline", handleOffline)
    }
  }, [])

  if (isOnline) return null

  return (
    <div
      className="fixed inset-x-0 top-0 z-[100] bg-red-600 text-white py-2 px-4 text-center text-sm font-medium"
      role="alert"
    >
      No Internet connection
    </div>
  )
}
